import { useContext } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import { Button } from "../button/button";
import { Navigation } from "../navigation/navigation";
import classes from "./hero.module.css";

export type HeroProps = {
	title: string;
	image: string;
};

export const Hero = ({ title, image }: HeroProps) => {
	const { texts } = useContext(LocaleContext);

	return (
		<section
			className={classes.hero}
			style={{
				backgroundImage: `linear-gradient(to bottom, rgba(0, 31, 63, 0.5), rgba(255, 255, 255, 0), rgba(0, 31, 63, 0.5)), url(${image})`,
			}}
		>
			<Navigation />
			<div className={classes.content}>
				<p className={classes.slogan}>{texts.hero.slogan}</p>
				<Button
					label={texts.hero.contact}
					url="#contact"
					variant="primary"
					size="large"
				/>
			</div>
		</section>
	);
};
